import { useI18n } from "../i18n/index.jsx";
const pl = {
  "Исторические записи": "Zapisy historyczne",
  "Рабочая ОСВ": "Robocze zestawienie obrotów i sald",
  "Настройки / план счетов": "Ustawienia / plan kont",
  "Сводка": "Przegląd",
  "Банк": "Bank",
  "Журнал": "Dziennik",
  "Расчёты": "Rozrachunki",
  "ОСВ": "Zestawienie obrotów i sald",
  "Налоги": "Podatki",
  "Отчёты и документы": "Raporty i źródła",
  "Сопоставлено": "Dopasowano",
  "Предложено": "Propozycja",
  "Не сопоставлено": "Nie dopasowano",
  "Вне периода księgi": "Poza okresem ksiąg",
  "Требует проверки": "Do weryfikacji",
  "Проверено": "Zweryfikowano",
  "Раздел пока недоступен на сервере. Повторите после обновления API.": "Moduł nie jest jeszcze dostępny na serwerze. Spróbuj po aktualizacji API.",
  "Не удалось выполнить запрос. Проверьте соединение и права доступа.": "Nie udało się wykonać żądania. Sprawdź połączenie i uprawnienia.",
  "Загрузка данных…": "Ładowanie danych…",
  "Повторить": "Ponów",
  "Нет данных по выбранным условиям.": "Brak danych dla wybranych warunków.",
  "Период": "Okres",
  "С": "Od",
  "По": "Do",
  "Przychody · доходы": "Przychody",
  "Koszty · расходы": "Koszty",
  "Dochód · результат CIT": "Dochód CIT",
  "Podatek · налог": "Podatek",
  "Zaliczka · аванс": "Zaliczka",
  "Сумма": "Kwota",
  "Счёт Wn": "Konto Wn",
  "Счёт Ma": "Konto Ma",
  "Целевой счёт": "Konto docelowe",
  "Дебет Wn": "Winien",
  "Кредит Ma": "Ma",
  "Источник": "Źródło",
  " · стр. ": " · str. ",
  "Стр. ": "Str. ",
  "; файл не привязан": "; brak powiązanego pliku",
  "Источник не привязан": "Brak powiązanego źródła",
  "Бухгалтерские книги · Księgi": "Księgi rachunkowe",
  "Выберите фирму в переключателе компании, чтобы открыть её книги и сверки.": "Wybierz firmę, aby otworzyć jej księgi i uzgodnienia.",
  "Браузер заблокировал просмотр. Файл скачан; откройте нужную страницу вручную.": "Przeglądarka zablokowała podgląd. Plik pobrano; otwórz właściwą stronę ręcznie.",
  "Бухгалтерские книги": "Księgi rachunkowe",
  "Обновить данные": "Odśwież dane",
  "Рабочие данные · bufor, не окончательная отчётность.": "Dane robocze — nie są ostatecznym sprawozdaniem.",
  "Изменение банковской классификации не создаёт проводку, не закрывает расчёты и не отправляет налоговую декларацию.": "Zmiana klasyfikacji bankowej nie tworzy dekretu, nie zamyka rozrachunków ani nie wysyła deklaracji.",
  "Книги · ledger cutoff": "Księgi — data graniczna",
  "Банк · bank cutoff": "Bank — data graniczna",
  "Периоды могут отличаться. Движение по банку — не остаток на счёте и не прибыль. Статус источника:": "Okresy mogą się różnić. Obroty bankowe nie są saldem ani zyskiem. Status źródła:",
  "Разделы бухгалтерских книг": "Moduły ksiąg rachunkowych",
  "Подготовка файла…": "Przygotowywanie pliku…",
  "Записи dziennik": "Zapisy dziennika",
  "Счета": "Konta",
  "Банковские операции": "Operacje bankowe",
  "Сопоставлено с книгами": "Dopasowane do ksiąg",
  "Банк: требуют проверки": "Bank: do weryfikacji",
  "Расчёты · rozrachunki": "Rozrachunki",
  "Снимки ОСВ": "Historyczne zestawienia obrotów i sald",
  "Документы": "Dokumenty",
  "Отчёты": "Raporty",
  "Сводка источников": "Przegląd źródeł",
  "Банковское движение · PLN": "Obroty bankowe · PLN",
  "Поступления": "Wpływy",
  "Списания": "Wydatki",
  "Чистое движение (не прибыль)": "Przepływy netto (nie zysk)",
  "Начало периода:": "Początek okresu:",
  "· Фискальные месяцы:": "· Miesiące roku obrotowego:",
  "Требует внимания": "Wymaga uwagi",
  "Дата": "Data",
  "Назначение": "Tytuł operacji",
  "Контрагент": "Kontrahent",
  "Сумма · PLN": "Kwota · PLN",
  "Валюта источника": "Waluta źródła",
  "Классификация": "Klasyfikacja",
  "Сверка": "Uzgodnienie",
  "Счёт:": "Konto:",
  "Действия": "Działania",
  "Проверить / изменить": "Sprawdź / zmień",
  "Документ": "Dokument",
  "Описание": "Opis",
  "Статус": "Status",
  "Wn · Дебет": "Winien",
  "Ma · Кредит": "Ma",
  "Страница": "Strona",
  "Проводка": "Dekret",
  "Открыть строки": "Otwórz pozycje",
  "Срок": "Termin płatności",
  "Счета RMK": "Konta RMK",
  "Целевой:": "Docelowe:",
  "Период / CIT (накопительно)": "Okres / CIT (narastająco)",
  "Данные источника": "Dane źródłowe",
  "Показать данные": "Pokaż dane",
  "Снимок nierozliczone rozrachunki на дату источника, не задолженность на сегодня. Банковское совпадение не означает автоматическую оплату или закрытие.": "Nierozliczone rozrachunki na dzień źródła, nie aktualne zadłużenie. Dopasowanie bankowe nie oznacza automatycznej zapłaty ani zamknięcia.",
  "Rozliczenia międzyokresowe kosztów: суммы и счета из источника. Расписание и проводки автоматически не создаются.": "Rozliczenia międzyokresowe kosztów: kwoty i konta ze źródła. Harmonogram i dekrety nie są tworzone automatycznie.",
  "CIT: расчёты могут быть накопительными — периоды нельзя суммировать. JPK: позиции источника, не полноценный реестр фактур и не подтверждение подачи.": "CIT: obliczenia mogą być narastające — nie sumuj okresów. JPK: pozycje źródłowe, nie pełny rejestr faktur ani potwierdzenie wysyłki.",
  "Поиск": "Szukaj",
  "Документ, описание, контрагент": "Dokument, opis, kontrahent",
  "Найти": "Szukaj",
  "Все статусы": "Wszystkie statusy",
  "Категория (код)": "Kategoria (kod)",
  "Все категории": "Wszystkie kategorie",
  "Вид": "Rodzaj",
  "JPK · позиции": "JPK · pozycje",
  "Строк": "Wiersze",
  "Скачать CSV · весь реестр": "Pobierz CSV · cały rejestr",
  "поиск: ": "szukaj: ",
  "все записи": "wszystkie zapisy",
  "Назад": "Wstecz",
  "Всего:": "Łącznie:",
  "0 записей": "Brak zapisów",
  "Далее": "Dalej",
  "Закрыть": "Zamknij",
  "Строки проводки · Wn / Ma": "Pozycje dekretu · Wn / Ma",
  "Счёт": "Konto",
  "Название": "Nazwa",
  "Валюта": "Waluta",
  "Проверка банковской операции #": "Weryfikacja operacji bankowej #",
  "Меняется только метка / workflow. Это НЕ księgowanie: проводка, налог и статус оплаты не изменяются.": "Zmieniasz tylko klasyfikację i weryfikację. To NIE jest księgowanie: dekret, podatek i stan rozliczenia pozostają bez zmian.",
  "Основания сопоставления · evidence": "Podstawa dopasowania",
  "Классификация (код из источника)": "Klasyfikacja (kod źródłowy)",
  "Проверка": "Weryfikacja",
  "Комментарий проверки": "Komentarz weryfikacji",
  "Сохранение…": "Zapisywanie…",
  "Сохранить метку": "Zapisz klasyfikację",
  "Отмена": "Anuluj",
  "Оборотно-сальдовая ведомость · OSV": "Historyczne zestawienie obrotów i sald",
  "Не суммируйте синтетические счета вместе с аналитическими. Wn / Ma сохранены раздельно; данные относятся к выбранному снимку.": "Nie sumuj kont syntetycznych z analitycznymi. Wn i Ma są oddzielne; dane dotyczą wybranego zestawienia.",
  "Снимок": "Zestawienie",
  "· документ": "· dokument",
  "Поиск счёта": "Szukaj konta",
  "Только синтетика (3 цифры)": "Tylko konta syntetyczne (3 cyfry)",
  "нет снимков": "brak zestawień",
  "Оборот Wn": "Obroty Wn",
  "Оборот Ma": "Obroty Ma",
  "Накоп. Wn": "Narastająco Wn",
  "Накоп. Ma": "Narastająco Ma",
  "Счетов:": "Liczba kont:",
  "Bilans / RZiS и cash report могут покрывать разные периоды. Рабочий отчёт и скачанный JPK не подтверждают окончательное закрытие или отправку в urząd.": "Bilans, RZiS i raport kasowy mogą obejmować różne okresy. Raport roboczy i pobrany JPK nie potwierdzają zamknięcia ksiąg ani wysyłki do urzędu.",
  "Поиск по названию, виду или имени файла": "Szukaj według nazwy, rodzaju lub pliku",
  "Отчёт": "Raport",
  "Исходные документы и рабочие отчёты": "Dokumenty źródłowe i raporty robocze",
  "Файл / SHA-256": "Plik / SHA-256",
  "Содержание": "Zawartość",
  "Данные отчёта": "Dane raportu",
  "Скачать источник": "Pobierz źródło",
  "Без вложения — см. данные отчёта": "Brak załącznika — zobacz dane raportu",
  "Найдено:": "Znaleziono:"
};
export function useBooksLanguage() {
  const {
    lang
  } = useI18n();
  return (ru, polish) => lang === "pl" ? polish ?? pl[ru] ?? ru : ru;
}
